/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedItems_viewer = {
    readonly isSeoQuicklookEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_viewer">;
    readonly " $refType": "SbSharedRelatedItems_viewer";
};
export type SbSharedRelatedItems_viewer$data = SbSharedRelatedItems_viewer;
export type SbSharedRelatedItems_viewer$key = {
    readonly " $data"?: SbSharedRelatedItems_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRelatedItems_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRelatedItems_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isSeoQuicklookEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SEO_QUICKLOOK"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'd6999807b1aacf5412b185816f616820';
export default node;
